/**
 * This file is auto-generated from PostCodeInput.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */

import type { Translation } from '@nzyme/i18n-core';

export const postalCode: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Postal Code';
        case 'pl':
            return 'Kod pocztowy';
    }
};
